import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n';
import type { AuraProcessingCost } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraProcessingCostsTable',
  props: {
    items: { type: Array, required: true },
    isLoading: { type: Boolean, required: true },
    formatCost: { type: Function, required: true },
    formatDate: { type: Function, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const { t, te } = useI18n();

const translateProcessingType = (processingType: string): string => {
    const key = `aura.processingCosts.processingTypes.${processingType}`;
    return te(key) ? t(key) : t('aura.processingCosts.processingTypes.unknown');
};

const translateSourceType = (sourceType: string): string => {
    const key = `aura.processingCosts.sourceTypes.${sourceType}`;
    return te(key) ? t(key) : t('aura.processingCosts.sourceTypes.unknown');
};

const translateStatus = (status: string): string => {
    const key = `aura.processingCosts.statuses.${status}`;
    return te(key) ? t(key) : t('aura.processingCosts.statuses.unknown');
};

const formatProcessingLabel = (item: AuraProcessingCost): string => {
    const processingType = translateProcessingType(item.processingType);

    return item.callId
        ? `${processingType} · ${t('aura.processingCosts.call', { callId: item.callId })}`
        : processingType;
};

const getStatusClass = (status: string): string => {
    const classes: Record<string, string> = {
        completed: 'bg-[#E6F9F5] text-[#159A87]',
        failed: 'bg-[#FDEBEC] text-[#C94B51]',
        skipped: 'bg-[#F1F3F5] text-[#626468]',
        pending: 'bg-[#FEF5DB] text-[#A56D00]',
        processing: 'bg-[#E8F0FE] text-[#3565B5]',
    };

    return classes[status] || classes.skipped;
};

const __returned__ = { t, te, translateProcessingType, translateSourceType, translateStatus, formatProcessingLabel, getStatusClass }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})